import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { InsightsHubState } from "@insightsHub/models";
import { fetchInsightsHubArticles, fetchInsightsHubArticleById } from "@insightsHub/store/thunks";
import { mapStrapiPortalArticle } from "@insightsHub/util/mapStrapiPortalArticle";
import ReduxUtils from "@shared/utils/ReduxUtils";
import { timeRangeOptions } from "@insightsHub/constants";

const initialState: InsightsHubState = {
  data: null,
  articleDetail: {
    id: null,
    data: null,
    loading: false,
    error: null,
  },
  filters: {
    timeRange: {
      timePeriod: timeRangeOptions[0],
      start: null,
      end: null,
    },
    selectedFormat: null,
    selectedAuthor: null,
    selectedBusinessSegment: null,
    searchInputKeyword: "",
  },
  loading: false,
  error: null,
};

const insightsHubSlice = createSlice({
  name: "insightsHub",
  initialState,
  reducers: {
    resetState: () => initialState,
    updateInsightFilters: (state, action: PayloadAction<Partial<InsightsHubState["filters"]>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInsightsHubArticles.pending, (state) => ReduxUtils.defaultPendingActionHandler(state))
      .addCase(fetchInsightsHubArticles.fulfilled, (state, action) => {
        const articles = Array.isArray(action.payload?.data) ? action.payload.data : [];

        ReduxUtils.defaultFulfilledActionHandler(
          state,
          articles.map((articleDto) => mapStrapiPortalArticle(articleDto))
        );
      })
      .addCase(fetchInsightsHubArticles.rejected, (state, action) =>
        ReduxUtils.defaultRejectedActionHandler(state, action.payload as string)
      )
      .addCase(fetchInsightsHubArticleById.pending, (state, action) => {
        state.articleDetail.id = action.meta.arg;
        state.articleDetail.loading = true;
        state.articleDetail.error = null;
      })
      .addCase(fetchInsightsHubArticleById.fulfilled, (state, action) => {
        state.articleDetail.id = action.meta.arg;
        state.articleDetail.data = action.payload;
        state.articleDetail.loading = false;
        state.articleDetail.error = null;
      })
      .addCase(fetchInsightsHubArticleById.rejected, (state, action) => {
        state.articleDetail.loading = false;
        state.articleDetail.error = (action.payload as string) ?? "Failed to fetch";
      });
  },
});

export const { resetState, updateInsightFilters } = insightsHubSlice.actions;
export default insightsHubSlice.reducer;
